import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Card, Form, Input, InputNumber, Button, message, Typography, Divider, Space } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { adminsApi } from '../api/client';

const { Title, Text } = Typography;

const SettingsCard = styled(Card)`
  max-width: 600px;
  border-radius: 12px;
`;

export function Settings() {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { data: settings, isLoading } = useQuery({
    queryKey: ['settings'],
    queryFn: async () => {
      const res = await adminsApi.getSettings();
      return res.data.data;
    },
  });

  const updateMutation = useMutation({
    mutationFn: async (values: Record<string, string>) => {
      const promises = Object.entries(values).map(([key, value]) =>
        adminsApi.updateSetting(key, value.toString())
      );
      return Promise.all(promises);
    },
    onSuccess: () => {
      message.success('Sozlamalar saqlandi!');
      queryClient.invalidateQueries({ queryKey: ['settings'] });
    },
    onError: () => {
      message.error('Xatolik yuz berdi');
    },
  });

  const handleSubmit = (values: any) => {
    updateMutation.mutate(values);
  };

  return (
    <div>
      <Title level={3}>Sozlamalar</Title>

      <SettingsCard loading={isLoading}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={settings}
        >
          <Title level={5}>To'lov sozlamalari</Title>
          
          <Form.Item
            name="POST_PRICE_UZS"
            label="E'lon narxi (so'm)"
          >
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              step={1000}
              formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={(value: any) => value.replace(/\$\s?|(,*)/g, '')}
            />
          </Form.Item>

          <Form.Item
            name="PAYMENT_CARD_NUMBER"
            label="Karta raqami"
          >
            <Input placeholder="8600 xxxx xxxx xxxx" />
          </Form.Item>

          <Form.Item
            name="PAYMENT_CARD_HOLDER"
            label="Karta egasi"
          >
            <Input placeholder="FAMILIYA ISM" />
          </Form.Item>

          <Divider />

          <Title level={5}>Telegram sozlamalari</Title>

          <Form.Item
            name="ADMIN_GROUP_ID"
            label="Admin guruh ID"
          >
            <Input placeholder="-100xxxxxxxxxx" />
          </Form.Item>

          <Form.Item
            name="PUBLIC_GROUP_ID"
            label="Ommaviy guruh ID"
          >
            <Input placeholder="-100xxxxxxxxxx" />
          </Form.Item>

          <Divider />

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              icon={<SaveOutlined />}
              loading={updateMutation.isPending}
              size="large"
            >
              Saqlash
            </Button>
          </Form.Item>
        </Form>
      </SettingsCard>
    </div>
  );
}
